module.exports = __webpack_public_path__ + "img/theme.549a48bb.svg";